module.exports = __webpack_public_path__ + "static/error_bg-d710f00e93b029cd0d7f93e7dcbc160c.png";